<template>
	<div class="openTabs">
        <loader v-if="pageLoader"></loader>
        <div v-if="(ticketList != '' && ticketList.totalRecords > 0)">
            <div class="listsys mb-3 d-flex justify-content-between align-items-start" v-for="list,index in ticketList.records" >
                <div class="ltr" @click="viewTicket(list.id)">
                    <p class="themecolor medium">
                        <span v-if="list.reason && parseInt(list.reason) == 91">Document Verification</span>
                        <span v-else-if="ticketReasonList[list.reason] && ticketReasonList[list.reason].categories && parseInt(list.title) != 0">
                            <label v-for="catlist in ticketReasonList[list.reason].categories" v-if="catlist.id == list.title"> {{catlist.title}}</label>
                        </span>
                        <span v-else-if="ticketReasonList[list.reason]">
                            {{ticketReasonList[list.reason].title}}
                        </span>
                        <span v-else>-</span>
                    </p>
                    <div class="d-flex align-items-center">
                        <!-- <span class="smallbtn  mr-3" :class="($parent.ticketsTab == '1')?'redBG':'textBG'">Urgent</span> -->
                        <span class="border_btn smallbtn themecolor">#{{list.ticket.slice(0, 7)}}</span>
                    </div>
                </div>
                <p class="mb-0">{{fromNow(list.created)}}</p>
            </div>
            <pagination
                :totalRecords="ticketList.totalRecords"
                :limit="pageLimit"
                :pageNo="page"
                v-if="ticketList.totalRecords > 0"
            />
        </div>
        <no-data v-else/>
        <!-- <div class="listsys mb-3 d-flex justify-content-between align-items-start">
            <div class="ltr">
                <p class="themecolor medium">Cannot access the system <sup class="status yellowBG f-10 p-1">New</sup></p>
                <div class="d-flex align-items-center">
                    <span class="smallbtn  mr-3" :class="($parent.ticketsTab == '1')?'redBG':'textBG'">Urgent</span>
                    <span class="border_btn smallbtn themecolor">#CW225</span>
                </div>
            </div>
            <p class="mb-0">1h ago</p>
        </div>
        <div class="listsys mb-3 d-flex justify-content-between align-items-start">
            <div class="ltr">
                <p class="themecolor medium">Cancel my order</p>
                <div class="d-flex align-items-center">
                    <span class="smallbtn  mr-3" :class="($parent.ticketsTab == '1')?'yellowBG':'textBG'">Medium</span>
                    <span class="border_btn smallbtn themecolor mr-3">#CW225</span>
                    <span class="messageChat d-flex align-items-center"><feather class="mr-1" size="18px" type="message-circle"></feather> 2</span>
                </div>
            </div>
            <p class="mb-0">1h ago</p>
        </div>
        <div class="listsys mb-3 d-flex justify-content-between align-items-start">
            <div class="ltr">
                <p class="themecolor medium">Rejected order</p>
                <div class="d-flex align-items-center">
                    <span class="smallbtn  mr-3" :class="($parent.ticketsTab == '1')?'greenBG':'textBG'">Urgent</span>
                    <span class="border_btn smallbtn themecolor mr-3">#CW225</span>
                    <span class="messageChat d-flex align-items-center"><feather class="mr-1" size="18px" type="message-circle"></feather> 3</span>
                </div>
            </div>
            <p class="mb-0">5h ago</p>
        </div> -->
    </div>
</template>
<script> 
    import { supportMixins } from '@/plugins/support'
    import moment from 'moment'
    export default {
        name: 'OPEN-TICKET',
        mixins: [supportMixins],
        data () {
            return {
                //===========prop in loader component=======
                col_span : 4,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                notification_msg:'',
                notification_type:'',
                loaderFuncRun : '1',
                //==========================================
                page : '1',
                search : '',
                pageLimit : '6'
            }
        },
        props:['pageLim'],
        watch:{
            '$parent.ticketsTab'(val){
                this.listing()
            }
        },
        methods:{
            viewTicket(listId){
                this.$router.push({name: 'view' , query: { 'id':listId}})
            },
            fromNow(val){
                return moment(val).fromNow()
            },
            listing(){
                let input_json={
                    'globalParams' :{
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                        'status' : this.$parent.ticketsTab
                    },
                    'localParams' :{ "parameter" : this ,'loaderFuncRun' : this.loaderFuncRun}
                }
                this._runGetTicketList(input_json)
            }
        },
        created(){
            this.listing()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/supports/ticket-list.vue